import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { site } from "@/config/site.config";

export const StickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 520);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-ink/90 backdrop-blur-md md:hidden"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <p className="pt-2 text-center font-mono text-[9px] tracking-[0.3em] text-cream/50">
            THE EXPERIENCE + 3 BOOKS + BONUSES
          </p>
          <div className="px-4 pb-3 pt-1.5">
            <a
              data-testid="sticky-cta-button"
              data-analytics-event="cta_click"
              data-analytics-cta="sticky"
              href={site.checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-full bg-lime py-3 text-sm font-extrabold tracking-[0.08em] text-ink"
            >
              ENTER — {site.price}
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
